/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

const useFetchExpedientesUsuario = (expediente, inicio = 0, mostrar = 12) => {
  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(
    (mostrar) => {
      if (loading || !expediente) return
      setLoading(true)

      axios
        .post(`/expedienteslisa/getExpedientesUsuarioTipo/`, { expediente, inicio, mostrar })
        .then((request_response) => {
          setResponse(request_response.data)
          setError(null)
        })
        .catch((request_error) => setError(request_error))
        .finally(() => setLoading(false))
    },
    [expediente, loading],
  )

  useEffect(() => {
    if (!loading) fetchData(mostrar)
  }, [expediente])

  return { response, error, loading, refetchExpedientes: fetchData }
}

export default useFetchExpedientesUsuario
